import { Header } from "@components/Header";
import { Navbar } from "@components/NavBar/Navbar";
import { PageLoader } from "@components/PageLoader";
import { useMobile } from "@lyteflo/utils";
import { type ReactNode, Suspense } from "preact/compat";

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const isMobile = useMobile();

  return (
    <div className="lf-flex lf-flex-col lf-min-w-[320px]">
      <div className="lf-fixed lf-top-0 lf-right-0 lf-left-0 lf-z-50">
        <Header />
        {!isMobile && <Navbar className="lf-sticky" />}
      </div>
      <main
        className={`lf-flex lf-flex-col lf-px-1 lf-mt-20 lf-mb-2 lf-mx-0 md:lf-mt-32 md:lf-mx-4`}
      >
        <Suspense fallback={<PageLoader />}>{children}</Suspense>
      </main>
      {isMobile && <Navbar />}
    </div>
  );
};
